// extracted by mini-css-extract-plugin
export default {"firstScreenSection":"FirstScreen_firstScreenSection__uCOuh","arrow":"FirstScreen_arrow__PPWvY","rocket":"FirstScreen_rocket__+UAKr","sputnik":"FirstScreen_sputnik__RsW2o"};